import { useModuleRedirect } from "../../hooks/useModuleRedirect";

const HazardousMaterialManageEntry = () => {
  useModuleRedirect("hazardous-materials");
  return null;
};

export default HazardousMaterialManageEntry;
